import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { ALargeSmall } from 'lucide-react'
import { InputWithIcon } from 'components/AdminConsole/commonUI/InputWithIcon'
import { getNestedError } from 'components/PopCreation/Form/utils'

const MAX_TITLE_LENGTH = 100

export const TitleField = () => {
  const { register, errors } = useFormContext()
  const t_name = useLocaleText('name', true)
  const t_placeholder = useLocaleText('title_placeholder', true)
  const validation_rule_is_required = useLocaleText('validation_rule_is_required', true)
  const error_title_max_length = useLocaleText('error_title_max_length', true)

  const error = getNestedError(errors, 'data.title')

  const validationRules = {
    required: validation_rule_is_required,
    maxLength: {
      value: MAX_TITLE_LENGTH,
      message: error_title_max_length,
    },
  }

  return (
    <StyledFormControl isInvalid={!!error} w="100%">
      <StyledFormLabel required>
        <ALargeSmall size={18} strokeWidth={2.5} />
        <Text>{t_name}</Text>
      </StyledFormLabel>
      <InputWithIcon name="data.title" ref={register(validationRules)} placeholder={t_placeholder} />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
